<template>
    <div>
        <el-row style="display: flex;margin-bottom: 10px;">
            <el-col :span="18" class='flex'>
                <el-select v-model='theTestId' @change="theTestIdChange" size="small" clearable placeholder="请选择作业">
                    <el-option v-for="item in getBwTaskList_data.data || []" :key="item.ybtId" :label="item.ybtTitle"
                        :value="item.ybtId">
                    </el-option>
                </el-select>
            </el-col>
            <el-col>
                <!-- <el-button v-if="getBwTaskRecordList" @click="user()"
                    size='small' type="primary" style="float:right" icon='el-icon-circle-plus'>同步公众号用户
                </el-button> -->
            </el-col>
        </el-row>
        <div>
            <myform :viewobj='{
                addYcVisitorQuestionTopicClass: ["新增拜访题目分类", "el-icon-circle-plus"],
                updateYcVisitorQuestionTopicClass: ["修改拜访题目分类", "el-icon-edit-outline"],
                $succeed$: getBwTaskRecordList
            }' @confirm='myform' @close='$form("addYcVisitorQuestionTopicClass", "reset")'>


                <hide slot='yvqtcId' />
            </myform>
            <mytable :tableColums='tableColums_getBwTaskRecordList' api='getBwTaskRecordList'
                xupdateapi='updateOpportunityBusinessCheckImage' :height="H - 165">
                <div slot="ybtFileImage" slot-scope="{row}" style="max-height:30vh;overflow:auto;max-width:99%;"
                    class="fCenter">
                    <img :src="img" alt="" loading="lazy" v-for="img in (row.ybtFileImage.split(','))"
                        onclick="document.PreviewVideo(this.src)" :title="'点击预览 ' + img" :key="img" />
                </div>
                <div slot="ybtFileDocument" slot-scope="{row}" style="max-height:30vh;overflow:auto;max-width:99%;"
                    class="fCenter">
                    <el-button
                        v-for="(img, index) in (row.ybtFileDocument && row.ybtFileDocument != ' ' ? row.ybtFileDocument.split(',') || [] : [])"
                        :key="index" size="mini" type="text" style="color: deepskyblue;margin: 0 10px;"
                        @click="DocumentLook(img)">
                        文件{{ index + 1 }}</el-button>
                </div>
                <div slot="ybtFileAudio" slot-scope="{row}" style="max-height:30vh;overflow:auto;max-width:99%;"
                    class="fCenter">
                    <a v-if="row.ybtFileAudio && row.ybtFileAudio != ' '" :href="row.ybtFileAudio">预览</a>
                    <!-- <audio :src="row.ybtFileAudio" style="width: 100%;"></audio> -->
                </div>
                <div slot="ybtFileVideo" slot-scope="{row}" style="max-height:30vh;overflow:auto;max-width:99%;color: red;"
                    class="fCenter" @click="PreviewVideo2(row.ybtFileVideo)">
                    {{ row.ybtFileVideo && row.ybtFileVideo != ' ' ? '预览' : '' }}
                </div>
            </mytable>
        </div>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
let Base64 = require("js-base64").Base64;
export default {
    data() {
        return {
            theTestId: 0,
            theProjectId: 0,
            value: '',
            form: {
                projectId: '',

            },
            tableColums_getBwTaskRecordList: {
                $selection: false,

                // oiType: '限制字段key',

                ybtrContent: '作业内容',
                ybtFileImage: ['图片', 200],
                ybtFileDocument: ['文档', 200],
                ybtFileAudio: ['音频', 80],
                ybtFileVideo: ['视频', 80],
                createtime: '提交时间',
                createusername: '学员',


            }
        }
    },
    methods: {
        PreviewVideo2(url) {
            if (url) {
                document.PreviewVideo(url)
            }
        },
        DocumentLook(URL) {
            window.open(`https://filepreview.aojuai.com/onlinePreview?url=${encodeURIComponent(Base64.encode(URL))}`)
        },
        theTestIdChange(e) {
            this.theTestId = e;
            this.getBwTaskRecordList({ ybtId: e });},
        parsch() {
            this.getBwTaskRecordList({
                yusSubscribe: this.yusSubscribe
            });
        },
        user() {
            this.getBwTaskRecordListSync();
        },
        myform(submit, Myformdata) {
            submit();
        },

    },
    created() {
        this.getBwTaskList({ projectId: this.form.projectId }).result(res => {
            this.theTestId = res.data.data[0].ybtId;
            this.getBwTaskRecordList({ ybtId: this.theTestId });
        });

    },
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/views/ClassManagement/testSub.vue